import { BASE_URL } from '..';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;
export const api_getEventTypes = async () => {
	const uri = `${BASE_URL}/catering/eventTypes`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getSubTypes = async () => {
	console.log("gio")
	const uri = `${BASE_URL}/catering/eventTypes/sub`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
				// Add your authorization token logic here if needed
			},
		});

		if (!response.ok) {
			throw new Error(
				`Failed to fetch sub types (${response.status} ${response.statusText})`,
			);
		}

		const data = await response.json();

		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};

export const api_getEventTypeById = async (id: string) => {
	const uri = `${BASE_URL}/catering/eventTypes/${id}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};
export const api_createEventType = async (payload: any) => {
	const uri = `${BASE_URL}/catering/eventTypes`;

	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the event type',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Event type created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};
export const api_editEventType = async (payload: any, eventTypeId: string) => {
	const uri = `${BASE_URL}/catering/eventTypes/${eventTypeId}`;

	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to edit the event type',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Event type edited successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteEventType = async (eventTypeId: string) => {
	const uri = `${BASE_URL}/catering/eventTypes/${eventTypeId}`;

	try {
		const response = await fetch(uri, {
			method: 'DELETE',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to delete the event type',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Event type deleted successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};
